import React from 'react';
import { useNavigate } from 'react-router-dom'; // Import useNavigate for navigation
import ComingSoon from '../../../../commonComponent/ComingSoon';

function Accounts() {
  const navigate = useNavigate(); // Initialize useNavigate for routing

  return (
    <div>
      <div className=" p-6 bg-gray-100">
        <header className="flex justify-between items-center mb-3 bg-white p-3">
          <h1 className="text-black text-xl font-bold ml-2">Finance and Accounting</h1>
          <div className="flex space-x-6">
            <button
              onClick={() => navigate('/dashboard/core-modules/finance/billing-invoicing')}
              className="btn "
            >
              Billing and Invoicing
            </button>
            <button
              onClick={() =>
                navigate('/dashboard/core-modules/finance/accounts-receivable-payable')
              }
              className="btn text-black font-bold"
            >
              Accounts Receivable/Payable
            </button>
            <button
              onClick={() => navigate('/dashboard/core-modules/finance/financial-reporting')}
              className="btn "
            >
              Financial Reporting
            </button>
            <button
              onClick={() => navigate('/dashboard/core-modules/finance/tax-management')}
              className="btn "
            >
              Tax Management
            </button>
            <button
              onClick={() => navigate('/dashboard/core-modules/finance/audit-logs')}
              className="btn "
            >
              Audit Logs
            </button>
          </div>
        </header>

        <ComingSoon />
      </div>
    </div>
  );
}

export default Accounts;

// import React, { useState } from 'react';
// import { useNavigate } from 'react-router-dom';

// function Accounts() {
//   const navigate = useNavigate();

//   return (
//     <div className="min-h-screen bg-gray-100">
//       <div className="p-6">
//         <header className="flex justify-between items-center mb-6 bg-white p-4 rounded-lg shadow-sm">
//           <h1 className="text-black text-xl font-bold">Finance and Accounting</h1>
//           <div className="flex space-x-6">
//             <button
//               onClick={() => navigate("/dashboard/core-modules/finance/billing-invoicing")}
//               className="text-dark-gray hover:text-black transition-colors"
//             >
//               Billing and Invoicing
//             </button>
//             <button
//               onClick={() => navigate("/dashboard/core-modules/finance/accounts-receivable-payable")}
//               className="text-black font-bold border-b-2 border-black pb-1"
//             >
//               Accounts Receivable/Payable
//             </button>
//             <button
//               onClick={() => navigate("/dashboard/core-modules/finance/financial-reporting")}
//               className="text-dark-gray hover:text-black transition-colors"
//             >
//               Financial Reporting
//             </button>
//             <button
//               onClick={() => navigate("/dashboard/core-modules/finance/tax-management")}
//               className="text-dark-gray hover:text-black transition-colors"
//             >
//               Tax Management
//             </button>
//           </div>
//         </header>

//         <AccountsReceivablePayable />
//       </div>
//     </div>
//   );
// }

// // Accounts Receivable/Payable Component
// function AccountsReceivablePayable() {
//   const [activeTab, setActiveTab] = useState('receivable');

//   // Sample data for receivables (money owed to the hotel)
//   const receivablesData = [
//     {
//       id: 'CUST-001',
//       name: 'John Smith',
//       invoiceNumber: 'INV-001',
//       dueDate: '2024-01-25',
//       amount: 450.00,
//       status: 'Pending',
//       contact: 'john.smith@email.com',
//       phone: '+1-555-0101'
//     },
//     {
//       id: 'CUST-002',
//       name: 'ABC Corporation',
//       invoiceNumber: 'INV-002',
//       dueDate: '2024-01-26',
//       amount: 1200.00,
//       status: 'Pending',
//       contact: 'billing@abccorp.com',
//       phone: '+1-555-0102'
//     },
//     {
//       id: 'CUST-003',
//       name: 'Sarah Johnson',
//       invoiceNumber: 'INV-003',
//       dueDate: '2024-01-15',
//       amount: 320.50,
//       status: 'Overdue',
//       contact: 'sarah.j@email.com',
//       phone: '+1-555-0103'
//     },
//     {
//       id: 'CUST-004',
//       name: 'Global Events Inc',
//       invoiceNumber: 'INV-004',
//       dueDate: '2024-02-01',
//       amount: 2500.00,
//       status: 'Pending',
//       contact: 'finance@globalevents.com',
//       phone: '+1-555-0104'
//     }
//   ];

//   // Sample data for payables (money the hotel owes to suppliers)
//   const payablesData = [
//     {
//       id: 'SUPP-001',
//       name: 'Fresh Food Suppliers',
//       invoiceNumber: 'SUPP-INV-001',
//       dueDate: '2024-01-28',
//       amount: 850.00,
//       status: 'Pending',
//       contact: 'accounts@freshfood.com',
//       phone: '+1-555-0201',
//       category: 'Food & Beverage'
//     },
//     {
//       id: 'SUPP-002',
//       name: 'CleanLinens Co.',
//       invoiceNumber: 'SUPP-INV-002',
//       dueDate: '2024-01-22',
//       amount: 320.00,
//       status: 'Pending',
//       contact: 'billing@cleanlinens.com',
//       phone: '+1-555-0202',
//       category: 'Housekeeping'
//     },
//     {
//       id: 'SUPP-003',
//       name: 'Tech Solutions Ltd',
//       invoiceNumber: 'SUPP-INV-003',
//       dueDate: '2024-01-18',
//       amount: 1500.00,
//       status: 'Overdue',
//       contact: 'payments@techsolutions.com',
//       phone: '+1-555-0203',
//       category: 'Technology'
//     },
//     {
//       id: 'SUPP-004',
//       name: 'Utility Services Inc',
//       invoiceNumber: 'SUPP-INV-004',
//       dueDate: '2024-02-05',
//       amount: 780.50,
//       status: 'Pending',
//       contact: 'billing@utilityservices.com',
//       phone: '+1-555-0204',
//       category: 'Utilities'
//     }
//   ];

//   // Summary calculations
//   const summary = {
//     totalReceivables: receivablesData.reduce((sum, item) => sum + item.amount, 0),
//     totalPayables: payablesData.reduce((sum, item) => sum + item.amount, 0),
//     overdueReceivables: receivablesData
//       .filter(item => item.status === 'Overdue')
//       .reduce((sum, item) => sum + item.amount, 0),
//     overduePayables: payablesData
//       .filter(item => item.status === 'Overdue')
//       .reduce((sum, item) => sum + item.amount, 0),
//     upcomingReceivables: receivablesData
//       .filter(item => item.status === 'Pending')
//       .reduce((sum, item) => sum + item.amount, 0),
//     upcomingPayables: payablesData
//       .filter(item => item.status === 'Pending')
//       .reduce((sum, item) => sum + item.amount, 0)
//   };

//   const handleMarkAsPaid = (id, type) => {
//     console.log(`Mark as paid: ${id} (${type})`);
//     // Implementation for marking as paid
//   };

//   const handleViewLedger = (id, type) => {
//     console.log(`View ledger: ${id} (${type})`);
//     // Implementation for viewing ledger
//   };

//   const handleSendReminder = (id, type) => {
//     console.log(`Send reminder: ${id} (${type})`);
//     // Implementation for sending reminder
//   };

//   const getStatusColor = (status) => {
//     switch (status) {
//       case 'Paid': return 'bg-green-100 text-green-800';
//       case 'Pending': return 'bg-yellow-100 text-yellow-800';
//       case 'Overdue': return 'bg-red-100 text-red-800';
//       default: return 'bg-gray-100 text-gray-800';
//     }
//   };

//   const currentData = activeTab === 'receivable' ? receivablesData : payablesData;

//   return (
//     <div className="bg-white rounded-lg shadow-sm p-6">
//       {/* Summary Cards */}
//       <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
//         <div className="bg-white border border-light-gray rounded-lg p-4 shadow-sm">
//           <h3 className="text-dark-gray text-sm font-medium mb-1">Total Receivables</h3>
//           <p className="text-black text-2xl font-bold">${summary.totalReceivables.toFixed(2)}</p>
//           <p className="text-red-600 text-sm mt-1">
//             Overdue: ${summary.overdueReceivables.toFixed(2)}
//           </p>
//         </div>
//         <div className="bg-white border border-light-gray rounded-lg p-4 shadow-sm">
//           <h3 className="text-dark-gray text-sm font-medium mb-1">Total Payables</h3>
//           <p className="text-black text-2xl font-bold">${summary.totalPayables.toFixed(2)}</p>
//           <p className="text-red-600 text-sm mt-1">
//             Overdue: ${summary.overduePayables.toFixed(2)}
//           </p>
//         </div>
//         <div className="bg-white border border-light-gray rounded-lg p-4 shadow-sm">
//           <h3 className="text-dark-gray text-sm font-medium mb-1">Upcoming Receivables</h3>
//           <p className="text-black text-2xl font-bold">${summary.upcomingReceivables.toFixed(2)}</p>
//           <p className="text-dark-gray text-sm mt-1">
//             {receivablesData.filter(item => item.status === 'Pending').length} invoices
//           </p>
//         </div>
//         <div className="bg-white border border-light-gray rounded-lg p-4 shadow-sm">
//           <h3 className="text-dark-gray text-sm font-medium mb-1">Upcoming Payables</h3>
//           <p className="text-black text-2xl font-bold">${summary.upcomingPayables.toFixed(2)}</p>
//           <p className="text-dark-gray text-sm mt-1">
//             {payablesData.filter(item => item.status === 'Pending').length} bills
//           </p>
//         </div>
//       </div>

//       <div className="flex flex-col lg:flex-row gap-6">
//         {/* Main Content */}
//         <div className="flex-1">
//           {/* Tab Navigation */}
//           <div className="flex border-b border-light-gray mb-6">
//             <button
//               onClick={() => setActiveTab('receivable')}
//               className={`px-4 py-2 font-medium border-b-2 transition-colors ${
//                 activeTab === 'receivable'
//                   ? 'border-black text-black'
//                   : 'border-transparent text-dark-gray hover:text-black'
//               }`}
//             >
//               Accounts Receivable
//             </button>
//             <button
//               onClick={() => setActiveTab('payable')}
//               className={`px-4 py-2 font-medium border-b-2 transition-colors ${
//                 activeTab === 'payable'
//                   ? 'border-black text-black'
//                   : 'border-transparent text-dark-gray hover:text-black'
//               }`}
//             >
//               Accounts Payable
//             </button>
//           </div>

//           {/* Table */}
//           <div className="overflow-x-auto">
//             <table className="w-full">
//               <thead>
//                 <tr className="border-b border-light-gray">
//                   <th className="text-left py-3 px-4 font-semibold text-black">
//                     {activeTab === 'receivable' ? 'Customer' : 'Supplier'}
//                   </th>
//                   <th className="text-left py-3 px-4 font-semibold text-black">Invoice #</th>
//                   <th className="text-left py-3 px-4 font-semibold text-black">Due Date</th>
//                   <th className="text-left py-3 px-4 font-semibold text-black">Amount</th>
//                   <th className="text-left py-3 px-4 font-semibold text-black">Status</th>
//                   <th className="text-left py-3 px-4 font-semibold text-black">Actions</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {currentData.map((item, index) => (
//                   <tr
//                     key={item.id}
//                     className={`border-b border-light-gray ${index % 2 === 0 ? 'bg-gray-50' : 'bg-white'}`}
//                   >
//                     <td className="py-3 px-4">
//                       <div>
//                         <p className="text-black font-medium">{item.name}</p>
//                         <p className="text-dark-gray text-sm">{item.contact}</p>
//                       </div>
//                     </td>
//                     <td className="py-3 px-4 text-black font-medium">{item.invoiceNumber}</td>
//                     <td className="py-3 px-4 text-dark-gray">{item.dueDate}</td>
//                     <td className="py-3 px-4 text-black font-medium">${item.amount.toFixed(2)}</td>
//                     <td className="py-3 px-4">
//                       <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${getStatusColor(item.status)}`}>
//                         {item.status}
//                       </span>
//                     </td>
//                     <td className="py-3 px-4">
//                       <div className="flex space-x-2">
//                         <button
//                           onClick={() => handleMarkAsPaid(item.id, activeTab)}
//                           className="bg-black text-white px-3 py-1 rounded text-sm font-medium hover:bg-gray-800 transition-colors"
//                         >
//                           Mark as Paid
//                         </button>
//                         <button
//                           onClick={() => handleViewLedger(item.id, activeTab)}
//                           className="border border-light-gray text-black px-3 py-1 rounded text-sm font-medium hover:bg-gray-50 transition-colors"
//                         >
//                           View Ledger
//                         </button>
//                         <button
//                           onClick={() => handleSendReminder(item.id, activeTab)}
//                           className="text-black hover:text-gray-700 transition-colors"
//                           title="Send Reminder"
//                         >
//                           <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                             <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8" />
//                           </svg>
//                         </button>
//                       </div>
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </div>
//         </div>

//         {/* Cash Flow Chart Sidebar */}
//         <div className="lg:w-80 bg-white border border-light-gray rounded-lg p-4 shadow-sm">
//           <h3 className="text-black font-semibold mb-4">Cash Flow Overview</h3>

//           {/* Simple bar chart representation */}
//           <div className="space-y-4">
//             <div>
//               <div className="flex justify-between text-sm text-dark-gray mb-1">
//                 <span>Receivables</span>
//                 <span>${summary.totalReceivables.toFixed(2)}</span>
//               </div>
//               <div className="w-full bg-gray-200 rounded-full h-2">
//                 <div
//                   className="bg-green-600 h-2 rounded-full"
//                   style={{ width: `${Math.min((summary.totalReceivables / (summary.totalReceivables + summary.totalPayables)) * 100, 100)}%` }}
//                 ></div>
//               </div>
//             </div>

//             <div>
//               <div className="flex justify-between text-sm text-dark-gray mb-1">
//                 <span>Payables</span>
//                 <span>${summary.totalPayables.toFixed(2)}</span>
//               </div>
//               <div className="w-full bg-gray-200 rounded-full h-2">
//                 <div
//                   className="bg-red-600 h-2 rounded-full"
//                   style={{ width: `${Math.min((summary.totalPayables / (summary.totalReceivables + summary.totalPayables)) * 100, 100)}%` }}
//                 ></div>
//               </div>
//             </div>
//           </div>

//           {/* Net Cash Flow */}
//           <div className="mt-6 pt-4 border-t border-light-gray">
//             <div className="flex justify-between items-center">
//               <span className="text-dark-gray">Net Cash Flow</span>
//               <span className={`text-lg font-bold ${
//                 summary.totalReceivables > summary.totalPayables ? 'text-green-600' : 'text-red-600'
//               }`}>
//                 ${(summary.totalReceivables - summary.totalPayables).toFixed(2)}
//               </span>
//             </div>
//           </div>

//           {/* Upcoming Payments */}
//           <div className="mt-6">
//             <h4 className="text-black font-medium mb-3">Upcoming This Week</h4>
//             <div className="space-y-2">
//               {[...receivablesData, ...payablesData]
//                 .filter(item => item.status === 'Pending')
//                 .slice(0, 3)
//                 .map((item, index) => (
//                   <div key={index} className="flex justify-between items-center text-sm">
//                     <span className="text-dark-gray truncate">{item.name}</span>
//                     <span className="text-black font-medium">${item.amount.toFixed(2)}</span>
//                   </div>
//                 ))}
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default Accounts;
